﻿import Swiper, {Navigation, Pagination} from 'swiper';
import { utils } from '../../Foundation';

export class Slider {
    constructor(element) {
        element.Slider = this;

        // References
        this.container = utils.hasId(element) ? utils.toId(element.getAttribute('id')) : utils.toClass(element.getAttribute('class'));

        // Properties
        this.data = typeof element.dataset != 'undefined' && element.dataset.slider != ''
                ? JSON.parse(element.dataset.slider)
                : {};

        this.options = this.setSettings(this.data);

        // Find outside scope
        const 
            oPreviusButton = element.parentElement.querySelector('.swiper-button-prev'),
            oNextButton = element.parentElement.querySelector('.swiper-button-next');
            
        if(oPreviusButton != null) {
            this.options.navigation.prevEl = oPreviusButton;
        }

        if(oNextButton != null) {
            this.options.navigation.nextEl = oNextButton;
        }

        // configure Swiper to use modules
        Swiper.use([Navigation, Pagination]);

        // Initiate
        new Swiper(this.container, this.options);
    }

    setSettings(data) {
        let cloneSettings = { ...this.settings }
        if(data.slidesPerGroup) {
            cloneSettings.breakpoints['992'].slidesPerGroup = data.slidesPerGroup;
            delete data.slidesPerGroup;
        }
        if(data.slidesPerView) {
            cloneSettings.breakpoints['992'].slidesPerView = data.slidesPerView;
            delete data.slidesPerView;
        }
        return { ...cloneSettings, ...data };
    }

    get settings() {
        return {
            speed: 600,
            spaceBetween: 30,
            loop: false,
            loopFillGroupWithBlank: true,
            navigation: {
                nextEl: `${this.container} .swiper-button-next`,
                prevEl: `${this.container} .swiper-button-prev`
            },
            breakpoints: {
                992: {
                    slidesPerGroup: 1,
                    slidesPerView: 1
                }
            }
        }
    }
}